import sanity from "/lib/sanity/client";

import Seo from "utils/seo";

import Footer from "components/Footer";
import CmsBlock from "components/CmsBlock";
import { Block, Section } from "/components/Layout";
import PortableText from "/components/cms/portableText";

import styles from "./Articles.module.scss";

type ArticlesProps = {
  page: {
    title: string;
    intro: { richText: any };
    content: any;
    slug: string;
  };
};

const Articles = ({ page }: ArticlesProps) => {
  const { content = [], title = "", intro = "", slug = "" } = page || {};

  return (
    <div>
      <Seo isFrontpage={false} page={page} />

      <article>
        <Section limitedWidth outer="firstSection">
          <Block mobileTop={4}>{title && <h1>{title}</h1>}</Block>

          {intro && <PortableText blocks={intro?.richText} />}
        </Section>

        <div className={styles.parallax}>
          {content?.map((item: { _key: string }) => (
            <CmsBlock data={item} key={item._key} />
          ))}
        </div>
      </article>

      <Footer slug={slug} />
    </div>
  );
};

const query = `*[_type == "page" && slug.current == "artikler"]{
  title,
  intro,
  thumbnail,
  content[]{
    ...,
    "articles": articles[]->{ title, intro, thumbnail, slug, content[]{...} },
    "faq": title, faq[]->{_id, title, richText, "category": category[]->{title}},
    "image": image{..., asset->{_id, metadata{dimensions, lqip}}},   
  },
  headerMedia,
  seo
}[0]`;

export const getStaticProps = async () => {
  const page = await sanity.fetch(query);
  return {
    props: {
      page
    }
  };
};

export default Articles;
